import { render, staticRenderFns } from "./BondRecordDetail.vue?vue&type=template&id=2bc89af0&scoped=true"
import script from "./BondRecordDetail.vue?vue&type=script&lang=js"
export * from "./BondRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./BondRecordDetail.vue?vue&type=style&index=0&id=2bc89af0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc89af0",
  null
  
)

export default component.exports